<template>
	<div class="pages">
		<div class="flexbox">
			<img v-if="faceShow==false" src='../../assets/face.png' />
			<img v-else src="../../assets/fail.png" />
		</div>
		<div style="margin-top: 10%;text-align: center;">
			<div class="submittext">{{faceShow==false?'信息采集成功':'信息采集失败'}}</div>
			<!-- 	<view class="riytext">欢迎使用如意刷</view> -->
		</div>
		<button v-if="faceShow==false" class="button" @click="submitHome">下一步</button>
		<button v-else class="button" @click="returnBack">返回</button>
	</div>
</template>
<script type="text/javascript" src="https://js.cdn.aliyun.dcloud.net.cn/dev/uni-app/uni.webview.1.5.2.js"></script>
<script type="text/javascript">
	import {
		getWillIdentifyResult,
		getWillIdentifyResultxcx
	} from '@/api/index';
	import wx from 'weixin-js-sdk';
	var ua = navigator.userAgent.toLowerCase();
	// import { Toast } from 'vant';
	export default {
		data() {
			return {
				faceShow: false,
				mid: '',
				urlStatus: ''
			};
		},
		created() {


		},
		mounted() {
			var url = window.location.href; //获取地址栏路径
			var temp1 = url.split('?'); //对url地址进行分割
			var pram = temp1[1];
			var keyValue = pram.split('&');
			var obj = {};
			for (var i = 0; i < keyValue.length; i++) {
				//循环分割挂过后的地址
				var item = keyValue[i].split('=');
				var key = item[0];
				var value = item[1];
				obj[key] = value;
			}
			if (obj.code != 0) {
				this.faceShow = true
			} else {
				this.faceShow = false
			}
			// 小程序接口
			if (ua.match(/MicroMessenger/i) == "micromessenger") {
				//ios的ua中无miniProgram，但都有MicroMessenger（表示是微信浏览器）
				wx.miniProgram.getEnv((res) => {
					if (res.miniprogram) {
						getWillIdentifyResultxcx(obj.orderNo, obj.code).then(res => {
							console.log(11111);
						})
					} else {
						getWillIdentifyResult(obj.orderNo, obj.code).then(res => {
							console.log(2222222);
						})
					}
				})
			} else {
				getWillIdentifyResult(obj.orderNo, obj.code).then(res => {
					console.log(2222222);
				})
			}


		},
		methods: {
			submitHome() {

				if (ua.match(/MicroMessenger/i) == "micromessenger") {
					//ios的ua中无miniProgram，但都有MicroMessenger（表示是微信浏览器）
					wx.miniProgram.getEnv((res) => {
						if (res.miniprogram) {
							wx.miniProgram.switchTab({
								url: "/pages/home/home",
								success: (res) => {

								}
							})

						} else {
							wx.miniProgram.switchTab({
								url: "/pages/home/home",
								success: (res) => {

								}
							})
						}
					})
				} else {
					this.$uni.switchTab({
						url: '/pages/home/home',
						success: (res) => {}
					})
				}



			},
			returnBack() {

				if (ua.match(/MicroMessenger/i) == "micromessenger") {
					//ios的ua中无miniProgram，但都有MicroMessenger（表示是微信浏览器）
					wx.miniProgram.getEnv((res) => {
						if (res.miniprogram) {
							wx.miniProgram.reLaunch({
								url: "/page_subject/pages/mydevice/mydevice",
								success: (res) => {

								}
							})

						} else {
							wx.miniProgram.reLaunch({
								url: "/page_subject/pages/mydevice/mydevice",
								success: (res) => {

								}
							})
						}
					})
				} else {
					this.$uni.reLaunch({
						url: '/pages/mydevice/mydevice',
						success: (res) => {

						}
					})
				}
			}
		}
	};
</script>
<style lang="scss">
	.pages {
		height: 100%;
		width: 100%;
		flex-wrap: nowrap;
		overflow: hidden;
	}

	.flexbox {
		width: 100%;
		height: 100px;
		background: #fff;
		display: flex;
		align-items: center;
		justify-content: center;
		margin-top: 10%;

		img {
			width: 80px;
			align-items: center;
			justify-content: center;
			margin-top: 20%;
		}
	}

	.submittext {
		font-size: 16px;
		font-weight: bold;
	}

	.riytext {
		font-size: 12px;
		font-weight: 400;
		color: #757880;
		margin-top: 1%;
	}

	.button {
		width: 95%;
		height: 45px;
		margin-left: 2.5%;
		margin-top: 15%;
		background: linear-gradient(270deg, #d69c63 0%, #f7ce9e 100%);
		border-radius: 28px;
		opacity: 1;
		font-size: 18px;
		line-height: 45px;
		font-family: PingFang SC-Bold, PingFang SC;
		font-weight: 500;
		box-shadow: 1px 5px 12px 1px rgba(247, 206, 158, 0.7);
		border: 0;
	}
</style>
